import { ListboxField_default } from "./chunk-N7Y3UXQ3.js";
import { Listbox_Option_default } from "./chunk-WBFIPXWH.js";

// src/components/ListboxField/index.tsx
var ListboxFieldComponent = ListboxField_default;
ListboxFieldComponent.Option = Listbox_Option_default;
ListboxFieldComponent.Option.displayName = "ListboxField.Option";
export { ListboxFieldComponent };